export const OVERVIEW_WIDGET_DATA = [
  {
    "type": "TEXT_HEADER",
    "data": {
      "title": "How is my online reputation?",
      "typographyProps": {
        "variant": "h5",
        "fontWeightType": "bold"
      }
    },
    "breakpoints": {
      "xxl": "100%",
      "xl": "100%",
      "lg": "100%",
      "md": "100%",
      "sm": "100%",
      "xs": "100%"
    }
  },
  {
    "type": "PIE_CHART",
    "enableActionBtn": true,
    "title": "Average Score",
    "subTitle": "Last 90 Days: Overall Score",
    "valueKeyToPlot": "average_score",
    "data": {
      "valueRange": {
        "min": 1,
        "max": 5
      },
      "angleRange": {
        "start": -160,
        "end": 160
      },
      "chartType": "progressGauge",
      "centerLabel": {
        "label": 0,
        "subLabel": "-0.00"
      },
      "baseSegments": [
        {
          "from": -160,
          "to": 80,
          "color": "#F6D1D3",
          "innerSize": 90,
          "size": 100
        },
        {
          "from": 81,
          "to": 160,
          "color": "#D1EFD6",
          "innerSize": 90,
          "size": 100
        }
      ],
      "indicatorSegments": [
        {
          "value": 3.54,
          "size": 105,
          "name": "Test",
          "color": "#1EB239",
          "innerSize": 80,
          "colorRanges": [
            {
              "from": 1,
              "to": 4.1,
              "color": "#E24A4A",
              "size": 105
            },
            {
              "from": 4.2,
              "to": 5,
              "color": "#1EB239",
              "size": 105
            }
          ]
        }
      ]
    },
    "cstData": {
      "columns": [
        "average_score",
        "benchmark_value",
        "sample_size",
        "benchmark_sample_size"
      ],
      "metric_data": [
        [
          3.36,
          2.88,
          137,
          147
        ]
      ],
      "metric_count": [
        [
          137,
          147
        ]
      ]
    },
    "lowSampleSize": 5,
    "breakpoints": {
      "xxl": "50%",
      "xl": "50%",
      "lg": "50%",
      "md": "50%",
      "sm": "100%",
      "xs": "100%"
    }
  },
  {
    "type": "REVIEW_VOLUME",
    "enableActionBtn": true,
    "title": "Review Volume",
    "subTitle": "Last 90 Days",
    "data": {
      "label": "Sample Size",
      "value": ""
    },
    "cstData": {
      "columns": [
        "review_count",
        "benchmark_value",
        "sample_size",
        "benchmark_sample_size"
      ],
      "metric_data": [
        [
          137,
          147,
          137,
          147
        ]
      ],
      "metric_count": [
        [
          137,
          147
        ]
      ]
    },
    "breakpoints": {
      "xxl": "50%",
      "xl": "50%",
      "lg": "50%",
      "md": "50%",
      "sm": "100%",
      "xs": "100%"
    }
  },
  {
    "type": "TEXT_HEADER",
    "data": {
      "title": "Management Response Status",
      "typographyProps": {
        "variant": "h5",
        "fontWeightType": "bold"
      }
    },
    "breakpoints": {
      "xxl": "100%",
      "xl": "100%",
      "lg": "100%",
      "md": "100%",
      "sm": "100%",
      "xs": "100%"
    }
  },
  {
    "type": "TOP_BOTTOM_TOPICS",
    "title": "Online Review Comments by Topic",
    "subTitle": "Time Period: Current Year to Date | Reporting Date: Responsedate | Question: Overall Score",
    "enableActionBtn": false,
    "enableSwitchTab": true,
    "switchOptions": [
      "TABLE",
      "BAR"
    ],
    "colorRules": {
      "ranges": [
        {
          "min": 1,
          "max": 999,
          "color": "#8ACA90"
        },
        {
          "min": 0,
          "max": 1,
          "color": "#E8F7EB"
        },
        {
          "min": -1,
          "max": 0,
          "color": "#F5D6D6"
        },
        {
          "min": -999,
          "max": -1,
          "color": "#E16067"
        }
      ]
    },
    "breakpoints": {
      "xxl": "100%",
      "xl": "100%",
      "lg": "100%",
      "md": "100%",
      "sm": "100%",
      "xs": "100%"
    },
    "cstDataV2": {
      "top_topics": [
        {
          "topic_label": "Staff",
          "impact_score": 274.39,
          "topic_filter_query": {
            "l1": "Staff"
          }
        },
        {
          "topic_label": "Services",
          "impact_score": 82.57,
          "topic_filter_query": {
            "l1": "Services"
          }
        },
        {
          "topic_label": "Brand",
          "impact_score": 4.44,
          "topic_filter_query": {
            "l1": "Brand"
          }
        },
        {
          "topic_label": "Property/Facilities",
          "impact_score": -24.61,
          "topic_filter_query": {
            "l1": "Property/Facilities"
          }
        },
        {
          "topic_label": "Pest",
          "impact_score": -41.43,
          "topic_filter_query": {
            "l1": "Pest"
          }
        }
      ],
      "bottom_topics": [
        {
          "topic_label": "Guest Room",
          "impact_score": -648.92,
          "topic_filter_query": {
            "l1": "Guest Room"
          }
        },
        {
          "topic_label": "Pest",
          "impact_score": -41.43,
          "topic_filter_query": {
            "l1": "Pest"
          }
        },
        {
          "topic_label": "Property/Facilities",
          "impact_score": -24.61,
          "topic_filter_query": {
            "l1": "Property/Facilities"
          }
        },
        {
          "topic_label": "Brand",
          "impact_score": 4.44,
          "topic_filter_query": {
            "l1": "Brand"
          }
        },
        {
          "topic_label": "Services",
          "impact_score": 82.57,
          "topic_filter_query": {
            "l1": "Services"
          }
        }
      ]
    }
  },
  {
    "type": "ONLINE_REVIEW_BY_PROPERTIES",
    "title": "Online Review By Properties",
    "subTitle": " ",
    "enableActionBtn": false,
    "enableSwitchTab": true,
    "switchOptions": [
      "TABLE",
      "TIME",
      "BAR"
    ],
  }
]
export const CHART_COLORS = ['#646FCF', '#6DBDFE', '#67E2E2', '#4294FE', '#00B6D2', '#00ACC8'];

export const getPieChartDefaultData = () => {
  return {
    exporting: { enabled: false },
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      events: {},
      spacing: [0, 0, 0, 0],
      margin: [0, 0, 0, 0]
    },
    title: {
      text: ''
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false
        },
        center: ['50%', '50%']
      }
    },
    series: [],
    credits: {
      enabled: false
    }
  };
};

export const REVIEW_RATING_BY_SITE_OPTIONS = [
  { label: '% of Reviews', value: '% of Reviews' },
  { label: 'Overall Score', value: 'Overall Score' }
];
